import type { FC } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import ActivateProfilesImage from './ActivateUnifyImage'

const copy = {
  heading: `Unify customer profile data in the warehouse to Engage customers everywhere`,
  description: `Deliver personalized, omnichannel campaigns to real-time targeted audiences from a centralized platform, without relying on other teams.`,
}

const link = {
  text: `Explore Twilio Engage Product`,
  url: `/product/twilio-engage/`,
}

const ActivateProfiles: FC = () => {
  const pageConfig = usePageConfig()

  return (
    <StyledSectionBase variant="2Col" reverse={true}>
      <Section.Contents>
        <ActivateProfilesImage alt={`Illustration: ${copy.heading}`} />
      </Section.Contents>
      <StyledCopy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h2" variant="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
          <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
        </CopyTextBase>
      </StyledCopy>
    </StyledSectionBase>
  )
}

export default ActivateProfiles

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
`

const StyledCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
    justify-self: end;
    align-self: center;
  }
`
